import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  currentPeriod,
  fetchTenantUsageHistory,
  fetchTenantUsageSummary,
  previousPeriod,
} from "../../lib/opsGraphql";

function exportCsv(rows, tenantId, period) {
  const header = "period,documents_processed,fallback_tokens,copilot_input,copilot_output\n";
  const body = rows
    .map(
      (r) =>
        `${r.period},${r.documents_processed},${r.fallback_tokens_used},${r.copilot_input_tokens || 0},${r.copilot_output_tokens || 0}`
    )
    .join("\n");
  const blob = new Blob([header + body], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `consumo-${tenantId}-${period}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export default function TenantConsumo() {
  const { tenantId } = useParams();
  const [period, setPeriod] = useState(currentPeriod());
  const [current, setCurrent] = useState(null);
  const [previous, setPrevious] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const prev = previousPeriod(period);
      const [cur, prevUsage, hist] = await Promise.all([
        fetchTenantUsageSummary(tenantId, period),
        fetchTenantUsageSummary(tenantId, prev),
        fetchTenantUsageHistory(tenantId, `${period}-01`, `${period}-28`),
      ]);
      setCurrent(cur);
      setPrevious(prevUsage);
      setHistory(hist.length ? hist : [cur, prevUsage].filter(Boolean));
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [tenantId, period]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <>
      <p>
        <Link to={`/tenants/${tenantId}`}>← Volver a ficha</Link>
      </p>
      {error && <p className="ops-error">{error}</p>}

      <div className="ops-card">
        <h2>Consumo por tenant</h2>
        <label>
          Período{" "}
          <input
            type="month"
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
            style={{ marginLeft: 8 }}
          />
        </label>
        <button type="button" className="ops-btn secondary" style={{ marginLeft: 8 }} onClick={refresh}>
          Actualizar
        </button>
        <button
          type="button"
          className="ops-btn secondary"
          style={{ marginLeft: 8 }}
          onClick={() => exportCsv(history, tenantId, period)}
        >
          Exportar CSV
        </button>
      </div>

      <div className="ops-stats-grid ops-card">
        <div>
          <span className="ops-stat-label">Mes actual ({period})</span>
          <strong>{current?.documents_processed ?? "—"} docs</strong>
          {current?.plan_exceeded && <span className="ops-badge danger">Excedido</span>}
          <br />
          <small>Fallback: {(current?.fallback_tokens_used || 0).toLocaleString("es-AR")} tokens</small>
        </div>
        <div>
          <span className="ops-stat-label">Mes anterior</span>
          <strong>{previous?.documents_processed ?? "—"} docs</strong>
          <br />
          <small>Fallback: {(previous?.fallback_tokens_used || 0).toLocaleString("es-AR")} tokens</small>
        </div>
        <div>
          <span className="ops-stat-label">Copilot (informativo)</span>
          <strong>
            {((current?.copilot_input_tokens || 0) + (current?.copilot_output_tokens || 0)).toLocaleString("es-AR")}{" "}
            tokens
          </strong>
        </div>
      </div>

      {loading && <p className="ops-loading">Cargando…</p>}
    </>
  );
}
